import script from "./PlanForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanForm.vue?vue&type=script&setup=true&lang=js"

import "./PlanForm.vue?vue&type=style&index=0&id=8380235c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8380235c"]])

export default __exports__